import { render, staticRenderFns } from "./balance-sheet.vue?vue&type=template&id=22919920&scoped=true&"
import script from "./balance-sheet.vue?vue&type=script&lang=js&"
export * from "./balance-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22919920",
  null
  
)

export default component.exports